import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import styles from './PreCancelDialog.module.css';

const PreCancelDialog = ({ isOpen, setIsOpen, onDismiss, handleClose }) => {
  return (
    <Dialog
      open={isOpen}
      keepMounted
      onClose={onDismiss}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{ style: { width: '500px' } }}
    >
      <div style={{ padding: 32 }}>
        <DialogTitle id="alert-dialog-slide-title" style={{ padding: 0 }}>
          <div style={{ fontWeight: '600' }}>Cancel request?</div>
        </DialogTitle>
        <div style={{ paddingBottom: '30px', paddingTop: '10px' }}>
          Note that once you close this form, all progress will be lost.
        </div>
        <DialogActions
          classes={{
            root: styles.popupControls,
          }}
          style={{
            padding: 0,
          }}
        >
          <Button
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Back to request
          </Button>
          <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClose}>
            Close form
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default PreCancelDialog;
